export enum LogLevel {
  OFF = "OFF",
  VERBOSE = "VERBOSE",
}
